import { getNewMovies } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';

export default function NewArrivals() {
  const newMovies = getNewMovies().slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950">
              <i className="ri-sparkling-line text-accent-500 mr-2"></i>
              最新上架
            </h2>
            <p className="text-sm text-foreground-500 mt-1">刚出炉的新鲜内容，快来看看吧</p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {newMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}